import { Component, OnInit } from '@angular/core';
import { WishApiService } from 'src/app/services/api/wish-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-wish-board',
  templateUrl: './wish-board.component.html',
  styleUrls: ['./wish-board.component.scss'],
})
export class WishBoardComponent implements OnInit {
  constructor(
    private api: WishApiService,
    private message: MessageService,
  ) {}

  submitting = false;
  currentWishes: any[] = [];

  ngOnInit(): void {
    this.fetchWishProducts();
  }

  async fetchWishProducts() {
    try {
      const r = await this.api.findWishProducts(1, 6);
      this.currentWishes = r.data.list || [];
    } catch (error) {
      // 静默失败
    }
  }

  async onWishSubmit(input: HTMLInputElement, event: Event) {
    event.preventDefault();
    const value = input.value.trim();
    if (!value) {
      this.message.warn('请先输入你想要的平台名称');
      input.focus();
      return;
    }

    this.submitting = true;
    try {
      await this.api.createWish(value);
      input.value = '';
      this.message.open(`已收到「${value}」的心愿`);
      await this.fetchWishProducts();
    } catch (error) {
      this.message.error('提交失败，请稍后重试');
    } finally {
      this.submitting = false;
    }
  }
}
